import styled from "styled-components";

export const Container = styled.footer`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  /* background-color: blue; */
  border-top-right-radius: 100px;
  margin-top: -3rem;
  line-height: 1.8rem;
  padding: 1rem;

  /* transform: skewY(-3deg*/
  /* p {
    padding-bottom: 10px;
  } */

  a {
    text-decoration: none;
    color: white;
  }
`;
